export default {
  FETCH_MESSAGE_TEXTS_REQUEST: 'FETCH_MESSAGE_TEXTS_REQUEST',
  FETCH_MESSAGE_TEXTS_SUCCESS: 'FETCH_MESSAGE_TEXTS_SUCCESS',
  FETCH_MESSAGE_TEXTS_FAILURE: 'FETCH_MESSAGE_TEXTS_FAILURE',
  UPDATE_MESSAGE_TEXT: 'UPDATE_MESSAGE_TEXT',
  SAVE_MESSAGE_TEXTS_REQUEST: 'SAVE_MESSAGE_TEXTS_REQUEST',
  SAVE_MESSAGE_TEXTS_SUCCESS: 'SAVE_MESSAGE_TEXTS_SUCCESS',
  SAVE_MESSAGE_TEXTS_FAILURE: 'SAVE_MESSAGE_TEXTS_FAILURE'
}
